import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Menu, X } from "lucide-react";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/explore", label: "Explore" },
  { to: "/centres", label: "Transplant Centers" },
  { to: "/share", label: "Share Your Journey" },
  { to: "/knowledge", label: "Knowledge" },
  { to: "/about#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e) => {
    e.preventDefault();
    if (q.trim()) { navigate(`/search?q=${encodeURIComponent(q.trim())}`); setOpen(false); setQ(""); }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="flex items-center">
          <img src="/assets/logo-full.png" alt="Transplant Story" className="h-9 w-auto transition-opacity hover:opacity-80" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-neutral-600 hover:text-ink font-medium transition-colors">
              {l.label}
            </Link>
          ))}
          <form onSubmit={submitSearch} className="flex items-center border border-neutral-200 rounded-full px-3 py-1.5 focus-within:border-rust transition-colors">
            <Search className="w-4 h-4 text-neutral-400" />
            <input
              data-testid="nav-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search"
              className="bg-transparent outline-none text-sm ml-2 w-40 placeholder:text-neutral-400"
            />
          </form>
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden p-2 -mr-2" onClick={() => setOpen(!open)}>
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white px-4 py-5 space-y-4">
          <form onSubmit={submitSearch} className="flex items-center border border-neutral-200 rounded-full px-3 py-2">
            <Search className="w-4 h-4 text-neutral-400" />
            <input data-testid="nav-search-input-mobile" value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Search centers, states, stories" className="bg-transparent outline-none text-sm ml-2 flex-1" />
          </form>
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block text-base font-medium text-ink py-1">{l.label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}
